(function(){
'use strict';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module('classy').component('cpPaypalWidget', {
  require: {
    ngModelCtrl: 'ngModel'
  },
  template: '\n    <div class="cp-paypal-widget">\n      <button\n        data-tracked-element="donation-page_checkout_paypal-btn" \n        type="button"\n        ng-click="$ctrl.openModal()"\n        ng-class="{\'logged-in\': $ctrl.model.status === $ctrl.constants.STATUS.SUCCESS}"\n        class="payment-method-select-btn__paypal"\n        id="btPaypal"\n        ng-show="$ctrl.model.status !== $ctrl.constants.STATUS.INACTIVE"\n        data-id="paymethod-paypal"\n      ><img ng-src="/static/global/images/payments/logo-paypal.svg" alt="PayPal"</button>\n    </div>\n  ',
  bindings: {
    model: '<',
    onReady: '&',
    onSuccess: '&',
    onCancel: '&',
    currency: '<',
    validateForm: '&'
  },
  controller: ["$window", "cpAPI", "cpConstants", "scDigitalWalletsService", "scScriptLoaderService", "$rootScope", function cpPaypalWidget($window, cpAPI, cpConstants, scDigitalWalletsService, scScriptLoaderService, $rootScope) {
    var _this = this;

    this.constants = cpConstants;
    this.config = {};

    this.$onChanges = function () {
      if (this.currency) {
        this.setupPaypal();
      }
    };

    this.openModal = function () {
      _this.onCancel();
      if (!_this.paypal) return;
      if (!_this.validateForm()) return;
      _this.paypal.initAuthFlow();
    };

    $rootScope.$on('openPaymentModal', function (_event, paymentMethod) {
      if (paymentMethod === _this.constants.PAYMENT_METHODS.PAYPAL) {
        _this.openModal();
      }
    });

    this.setupPaypal = function () {
      var _this2 = this;

      cpAPI.getBraintreeToken(this.currency).then(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(token) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!$window.braintree) {
                    scScriptLoaderService.loadScript('https://js.braintreegateway.com/v2/braintree.js').then(function () {
                      _this2.braintreeSetup(token);
                    }).catch(function (error) {
                      bugsnagClient.notify(error);
                    });
                  } else {
                    _this2.braintreeSetup(token);
                  }

                case 1:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());

      this.braintreeSetup = function (token) {
        $window.braintree.setup(token, 'custom', {
          paypal: {
            headless: true,
            onCancelled: _this2.onPaypalCancel
          },
          onPaymentMethodReceived: function onPaymentMethodReceived(params) {
            _this2.model.status = cpConstants.STATUS.SUCCESS;
            _this2.model.nonce = params.nonce;
            _this2.onSuccess({ params: params });

            _this2.ngModelCtrl.$setValidity('required', true);
            _this2.ngModelCtrl.$setDirty();
          },
          onReady: function onReady(params) {
            _this2.paypal = params.paypal;
            _this2.teardown = params.teardown;
            _this2.onReady();
          }
        });
      };

      this.onPaypalCancel = function () {
        _this2.model.status = cpConstants.STATUS.READY;
        _this2.model.nonce = null;
        _this2.onCancel();

        _this2.ngModelCtrl.$setViewValue(null);
        _this2.ngModelCtrl.$setPristine();
        _this2.ngModelCtrl.$setUntouched();
      };

      scDigitalWalletsService.addOnDigitalWalletsSubmitListener(function () {
        if (_this2.model.status === cpConstants.STATUS.SUCCESS) {
          _this2.onPaypalCancel();
        }
      });
    };
  }]
});
})();